<template>
  <button
    class="button button--icon button--green"
    @click="sync()"
    :disabled="isSynchronized"
  >
    <icon
      icon="plus"
      icon-classes="button__icon button__icon--left icon--white icon__plus--small"
    />
    <span class="icon icon--export button__icon button__icon--left icon--white"
      ><!--?xml version="1.0" encoding="utf-8"?-->
      <!-- Generator: Adobe Illustrator 24.2.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
      <svg
        version="1.1"
        baseProfile="basic"
        id="Warstwa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="14px"
        height="16px"
        viewBox="0 0 14 16"
        xml:space="preserve"
      >
        <g>
          <path
            fill="#DEDEDE"
            d="M2.3,5.5C2.3,5.5,2.3,5.5,2.3,5.5c0.3,0.3,0.8,0.3,1.1,0l2.8-2.8V9c0,0.4,0.3,0.8,0.8,0.8
		c0.4,0,0.8-0.3,0.8-0.8V2.6l2.8,2.8c0.3,0.3,0.8,0.3,1.1,0c0.3-0.3,0.3-0.8,0-1.1L7.5,0.2c0,0,0,0,0,0c-0.3-0.3-0.8-0.3-1.1,0
		L2.3,4.4C2,4.7,2,5.1,2.3,5.5L2.3,5.5z"
          ></path>
          <path
            fill="#DEDEDE"
            d="M13.2,10.3c-0.4,0-0.8,0.3-0.8,0.8v3.1v0c0,0.1-0.1,0.3-0.3,0.3H1.8c-0.1,0-0.3-0.1-0.3-0.3v-3.1
		c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v3.1c0,1,0.8,1.8,1.8,1.8h10.3c1,0,1.8-0.8,1.8-1.8v-3.1
		C13.9,10.7,13.6,10.3,13.2,10.3z"
          ></path>
        </g>
      </svg>
    </span>
    <span class="button__text">{{
      isSynchronized ? "Synchronizuję..." : "Synchronizuj słowniki"
    }}</span>
  </button>
</template>
<script>
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
import axios from "axios";

export default {
  data() {
    return {
      isSynchronized: false,
    };
  },
  components: {},

  methods: {
    async sync() {
      this.isSynchronized = true;
      try {
        await axios.post(API_BASE_URL + "/synchronize-woo/dictionaries");

        this.$root.$emit("noticesBox", {
          type: "success",
          message: "Synchronizacja słowników zakończona.",
        });
        this.isSynchronized = false;
      } catch (exception) {
        this.$root.$emit("noticesBox", exception.response.data);
        this.isSynchronized = false;
      }
    },
  },
};
</script>